(function () {
    "use strict";

    app.service("TrackingService", function () {
        this.trigger = function (category, action) {
            try {
                window.ga && window.ga.apply(window, ["send", "event", category, action]);
                if(window.dataLayer) {
                    window.dataLayer.push({
                        "event": "click_link",
                        "content_group": category,
                        "link_text": action === "on" ? "select" : action === "off" ? "unselect" : action
                    })
                    window.dataLayer.push({
                        "content_group": null,
                        "link_text": null
                    })
                }
            } catch (e) {
                // Do nothing
            }
        };
    });
})();